import { render, staticRenderFns } from "./shengyinow.vue?vue&type=template&id=27460848&scoped=true&"
import script from "./shengyinow.vue?vue&type=script&lang=js&"
export * from "./shengyinow.vue?vue&type=script&lang=js&"
import style0 from "./shengyinow.vue?vue&type=style&index=0&id=27460848&prod&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "27460848",
  null
  
)

export default component.exports